import { render, staticRenderFns } from "./ClinicianAddMeasureToPatient.vue?vue&type=template&id=4842b57e&scoped=true"
import script from "./ClinicianAddMeasureToPatient.vue?vue&type=script&lang=js"
export * from "./ClinicianAddMeasureToPatient.vue?vue&type=script&lang=js"
import style0 from "./ClinicianAddMeasureToPatient.vue?vue&type=style&index=0&id=4842b57e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4842b57e",
  null
  
)

export default component.exports